const AuthProviders = {
  InternalUserPassword: {
    id: "dfbe0791-d782-4efa-9c86-5b61e11427f8",
    name: "Login/Password",
    icon: "mdi-account",
    color: "#973F8D"
  },
  Ldap: {
    id: "ac1cfd9f-aa3f-4cb6-80d9-2b60888711b2",
    name: "mdi-domain",
    icon: "mdi-account-group",
    color: "#0088cc"
  },
  Apple: {
    id: "302cfe92-befc-4daf-a5ed-43920d3ab183",
    name: "Apple",
    icon: "mdi-apple",
    color: "#5e5e5e"
  },
  Telegram: {
    id: "536cd1f6-352d-49c0-a81c-64b98cc1c633",
    name: "Telegram",
    icon: "mdi-message-bulleted",
    color: "#0088cc"
  },
  Facebook: {
    id: "e1743ce0-3cc5-4279-8bbb-d72874889f5c",
    name: "Facebook",
    icon: "mdi-facebook",
    color: "#1877f2"
  },
  Google: {
    id: "95b96303-fd79-4c83-b56f-df3a4d94753c",
    name: "Google",
    icon: "mdi-google",
    color: "#4285F4"
  },
  Ntml: {
    id: "537f0944-61f5-46be-a017-2d35784b1dd1",
    name: "Ntlm",
    icon: "uim:sign-in",
    color: "#49973f"
  }
};
const AuthProvidersArray = [
  AuthProviders.InternalUserPassword,
  AuthProviders.Ldap,
  AuthProviders.Apple,
  AuthProviders.Telegram,
  AuthProviders.Facebook,
  AuthProviders.Google,
  AuthProviders.Ntml
];
export {
  AuthProviders,
  AuthProvidersArray
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
